(function() {
  if (window.WannaPartyMegaMenu) {
    window.WannaPartyMegaMenu.refresh();
    return;
  }

  var activeDetails = null;
  var switchTimer = null;
  var closeTimer = null;
  var pendingDetails = null;
  var pendingPointerX = 0;
  var pendingPointerY = 0;
  var pendingEntryX = 0;
  var pendingEntryY = 0;
  var pendingIntent = null;
  var lastPointerX = null;
  var lastPointerY = null;
  var deliberateCrossRowDelay = 90;
  var downwardTransitDelay = 700;
  var closeDelay = 360;

  function closeOtherMenus(currentDetails) {
    document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(function(details) {
      if (details !== currentDetails) details.removeAttribute('open');
    });
  }

  function positionMegaMenu(details) {
    var summary = details.querySelector('summary.header__menu-item');
    var content = details.querySelector('.mega-menu__content');
    var menuList = details.closest('.list-menu--inline');
    if (!summary || !content || !menuList) return;

    var summaryRect = summary.getBoundingClientRect();
    var menuRect = menuList.getBoundingClientRect();
    var hoverBridgeOverlap = 1;

    if (content.classList.contains('mega-menu__content--compact')) {
      var viewportGutter = 16;
      var compactTop = Math.max(0, summaryRect.height - hoverBridgeOverlap);

      content.style.setProperty('top', Math.round(compactTop) + 'px', 'important');
      content.style.left = '0px';
      content.style.right = 'auto';

      var contentWidth = content.getBoundingClientRect().width;
      var minimumLeft = viewportGutter - summaryRect.left;
      var maximumLeft = window.innerWidth - viewportGutter - summaryRect.left - contentWidth;
      var compactLeft = Math.min(0, maximumLeft);

      content.style.left = Math.round(Math.max(minimumLeft, compactLeft)) + 'px';
    } else {
      var top = Math.max(0, summaryRect.bottom - menuRect.top - hoverBridgeOverlap);

      content.style.setProperty('top', Math.round(top) + 'px', 'important');
      content.style.left = '0px';
      content.style.right = '0px';
    }
  }

  function getMegaMenuDetails(target) {
    if (!target || !target.closest) return null;
    return target.closest('.header__inline-menu details.mega-menu');
  }

  function cancelSwitch() {
    if (switchTimer) clearTimeout(switchTimer);
    switchTimer = null;
    pendingDetails = null;
    pendingIntent = null;
  }

  function cancelClose() {
    if (!closeTimer) return;
    clearTimeout(closeTimer);
    closeTimer = null;
  }

  function isSameRow(firstDetails, secondDetails) {
    var firstSummary = firstDetails && firstDetails.querySelector('summary.header__menu-item');
    var secondSummary = secondDetails && secondDetails.querySelector('summary.header__menu-item');
    if (!firstSummary || !secondSummary) return true;

    return Math.abs(firstSummary.getBoundingClientRect().top - secondSummary.getBoundingClientRect().top) < 4;
  }

  function openMenu(details) {
    cancelSwitch();
    cancelClose();
    closeOtherMenus(details);
    details.setAttribute('open', '');
    activeDetails = details;
    requestAnimationFrame(function() { positionMegaMenu(details); });
  }

  function scheduleClose(details) {
    cancelClose();
    closeTimer = setTimeout(function() {
      if (activeDetails !== details) return;
      details.removeAttribute('open');
      activeDetails = null;
      closeTimer = null;
    }, closeDelay);
  }

  function restartCrossRowTimer(delay, pointerX, pointerY) {
    if (switchTimer) clearTimeout(switchTimer);
    pendingPointerX = pointerX;
    pendingPointerY = pointerY;
    switchTimer = setTimeout(function() {
      var detailsToOpen = pendingDetails;
      switchTimer = null;
      pendingDetails = null;
      pendingIntent = null;
      if (detailsToOpen) openMenu(detailsToOpen);
    }, delay);
  }

  function isDownwardTransit(details, pointerX, pointerY) {
    var activeSummary = activeDetails && activeDetails.querySelector('summary.header__menu-item');
    var candidateSummary = details && details.querySelector('summary.header__menu-item');
    if (!activeSummary || !candidateSummary) return false;

    var activeTop = activeSummary.getBoundingClientRect().top;
    var candidateTop = candidateSummary.getBoundingClientRect().top;
    if (candidateTop <= activeTop + 4) return false;
    if (lastPointerX === null || lastPointerY === null) return true;

    var deltaX = pointerX - lastPointerX;
    var deltaY = pointerY - lastPointerY;

    return deltaY >= 0 && Math.abs(deltaY) >= Math.abs(deltaX) * 0.35;
  }

  function scheduleCrossRowOpen(details, pointerX, pointerY) {
    cancelSwitch();
    pendingDetails = details;
    pendingEntryX = pointerX;
    pendingEntryY = pointerY;
    pendingIntent = isDownwardTransit(details, pointerX, pointerY) ? 'transit' : 'deliberate';
    restartCrossRowTimer(
      pendingIntent === 'transit' ? downwardTransitDelay : deliberateCrossRowDelay,
      pointerX,
      pointerY
    );
  }

  function onMouseOver(event) {
    var details = getMegaMenuDetails(event.target);
    if (!details || details.contains(event.relatedTarget)) return;

    cancelClose();

    if (activeDetails && activeDetails !== details && !isSameRow(activeDetails, details)) {
      scheduleCrossRowOpen(details, event.clientX, event.clientY);
      return;
    }

    openMenu(details);
  }

  function onMouseMove(event) {
    lastPointerX = event.clientX;
    lastPointerY = event.clientY;

    if (!pendingDetails || !pendingDetails.contains(event.target)) return;

    var distance = Math.abs(event.clientX - pendingPointerX) + Math.abs(event.clientY - pendingPointerY);
    if (distance < 2) return;

    if (pendingIntent === 'transit') {
      var horizontalTravel = Math.abs(event.clientX - pendingEntryX);
      var verticalTravel = Math.abs(event.clientY - pendingEntryY);
      var upwardTravel = pendingEntryY - event.clientY;

      if ((horizontalTravel > 18 && verticalTravel < 8) || upwardTravel > 4) {
        pendingIntent = 'deliberate';
      }
    }

    restartCrossRowTimer(
      pendingIntent === 'transit' ? downwardTransitDelay : deliberateCrossRowDelay,
      event.clientX,
      event.clientY
    );
  }

  function onMouseOut(event) {
    var details = getMegaMenuDetails(event.target);
    if (!details || details.contains(event.relatedTarget)) return;

    if (details !== activeDetails) {
      cancelSwitch();
      if (activeDetails && (!event.relatedTarget || !activeDetails.contains(event.relatedTarget))) {
        scheduleClose(activeDetails);
      }
      return;
    }

    scheduleClose(details);
  }

  function onClick(event) {
    var summary = event.target.closest && event.target.closest('.header__inline-menu details.mega-menu > summary');
    if (!summary) return;

    var url = summary.getAttribute('data-url');
    if (url && url !== '#') return;

    event.preventDefault();

    var details = summary.closest('details.mega-menu');
    if (!details) return;

    openMenu(details);
  }

  function onToggle(event) {
    var details = event.target;
    if (!details.matches || !details.matches('.header__inline-menu details.mega-menu')) return;

    var summary = details.querySelector('summary.header__menu-item');
    var isOpen = details.hasAttribute('open');
    if (summary) summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (isOpen) {
      if (activeDetails !== details) {
        closeOtherMenus(details);
        activeDetails = details;
      }
      requestAnimationFrame(function() { positionMegaMenu(details); });
    } else if (activeDetails === details) {
      activeDetails = null;
    }
  }

  function refreshOpenMenu() {
    var openDetails = document.querySelector('.header__inline-menu details.mega-menu[open]');
    if (openDetails) {
      activeDetails = openDetails;
      positionMegaMenu(openDetails);
    }
  }

  document.addEventListener('mouseover', onMouseOver);
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseout', onMouseOut);
  document.addEventListener('click', onClick);
  document.addEventListener('toggle', onToggle, true);
  window.addEventListener('resize', refreshOpenMenu);

  window.WannaPartyMegaMenu = {
    position: positionMegaMenu,
    refresh: refreshOpenMenu
  };
})();
